var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBgPatternFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 948,
    viewBox: "0 0 1920 948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 12,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 12,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 12,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 12,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 12,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 12,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 12,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 100,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 100,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 100,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 100,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 100,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 100,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 100,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 44)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 44)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 44)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 44)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 44)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 44)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 44)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 44)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 276,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 276,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 276,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 276,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 276,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 276,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 276,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 364,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 364,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 364,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 364,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 364,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 364,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 364,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 308)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 308)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 308)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 308)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 308)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 308)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 308)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 308)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 540,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 540,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 540,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 540,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 540,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 540,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 540,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 628,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 628,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 628,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 628,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 628,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 628,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 628,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 572)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 572)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 572)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 572)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 572)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 572)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 572)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 572)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 804,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 804,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 804,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 804,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 804,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 804,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 804,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 892,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 892,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 892,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 892,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 892,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 892,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 892,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 836)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 836)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 836)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 836)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 836)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 836)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 836)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 836)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 132)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 132)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 132)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 132)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 132)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 132)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 132)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 132)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 220)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 220)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 220)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 220)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 220)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 220)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 220)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 220)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 188,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 188,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 188,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 188,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 188,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 188,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 188,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 396)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 396)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 396)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 396)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 396)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 396)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 396)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 396)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 484)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 484)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 484)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 484)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 484)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 484)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 484)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 484)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 452,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 452,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 452,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 452,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 452,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 452,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 452,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 660)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 660)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 660)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 660)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 660)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 660)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 660)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 660)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 748)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 748)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 748)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 748)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 748)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 748)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 748)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 748)",
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1082,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1346,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1434,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1478,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1566,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1654,
    cy: 716,
    r: 12,
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 716,
    r: 12,
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1742,
    cy: 716,
    r: 12,
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1786,
    cy: 716,
    r: 12,
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1830,
    cy: 716,
    r: 12,
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1874,
    cy: 716,
    r: 12,
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1918,
    cy: 716,
    r: 12,
    fill: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1906 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1862 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1818 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1774 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1730 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1686 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1642 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1598 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1554 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1510 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1466 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1422 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1378 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1334 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1290 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1246 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1202 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1158 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1114 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1070 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 1026 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 982 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 938 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 894 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 850 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 806 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 762 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 718 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 674 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 630 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 586 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 542 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 498 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 454 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 410 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 366 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 322 924)",
    fill: "#FF7B1C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 278 924)",
    fill: "#E13EED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 234 924)",
    fill: "#6F2ECA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 190 924)",
    fill: "#F53135"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 146 924)",
    fill: "#3180F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 102 924)",
    fill: "#18DF71"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 58 924)",
    fill: "#FEAB35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 14 924)",
    fill: "#FF7B1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgPatternFigma);
export default __webpack_public_path__ + "static/media/hero_bg_pattern_figma.a7fe62cfb1669fd22561b25d111acb7d.svg";
export { ForwardRef as ReactComponent };